// src/features/context/logic.ts
// Small helpers for the context resolution inspector.
// See docs/ux/context-ia.md.

export function enumSuffix(value: string | undefined, prefix: string): string {
  if (!value) return 'unspecified';
  return value.startsWith(prefix) ? value.slice(prefix.length).toLowerCase() : value.toLowerCase();
}

export function tryParseJson<T>(text: string): { value?: T; error?: string } {
  if (!text.trim()) return { error: 'Empty' };
  try {
    return { value: JSON.parse(text) as T };
  } catch (e) {
    return { error: e instanceof Error ? e.message : String(e) };
  }
}
